module.exports = __webpack_public_path__ + "img/edit_event_step1_off.9c7c6158.png";